import { socket } from "../socket";

export const fetchAwaitingUserCount = (token, workspaceId = null, lang = "en") => {
    if (!token) return Promise.resolve(0);

    return new Promise((resolve) => {
        const requestId = `support_tickets:awaiting-count-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const handler = (response = {}) => {
            if (response.request_id !== requestId) {
                return;
            }
            socket.off("support_tickets:awaiting-count-response", handler);
            if (response.status === 1) {
                const count = response.count ?? response.awaiting_user_count ?? 0;
                resolve(Number.isFinite(count) ? count : 0);
            } else {
                resolve(0);
            }
        };

        socket.on("support_tickets:awaiting-count-response", handler);
        socket.emit("support_tickets:awaiting-count", {
            request_id: requestId,
            token,
            workspace_id: workspaceId,
            lang,
        });

        setTimeout(() => {
            socket.off("support_tickets:awaiting-count-response", handler);
            resolve(0);
        }, 10000);
    });
};
